import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import PublicFormPage from './pages/PublicFormPage';
import LoginPage from './pages/LoginPage';
import AdminLayout from './pages/AdminLayout';

const PrivateRoute = ({ children }) => {
    const { estConnecte, loading } = useAuth();
    if (loading) return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
            <div style={{ width: 40, height: 40, border: '3px solid #e2e8f0', borderTopColor: '#1e6fe0', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }}></div>
            <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
        </div>
    );
    return estConnecte ? children : <Navigate to="/admin/login" replace />;
};

const PublicRoute = ({ children }) => {
    const { estConnecte, loading } = useAuth();
    if (loading) return null;
    return estConnecte ? <Navigate to="/admin" replace /> : children;
};

const AppRoutes = () => (
    <Routes>
        <Route path="/" element={<PublicFormPage />} />
        <Route path="/admin/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
        <Route path="/admin" element={<PrivateRoute><AdminLayout /></PrivateRoute>} />
        <Route path="/admin/*" element={<PrivateRoute><AdminLayout /></PrivateRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
);

const App = () => (
    <BrowserRouter>
        <AuthProvider>
            <AppRoutes />
            <Toaster
                position="top-right"
                toastOptions={{
                    duration: 3500,
                    style: {
                        fontFamily: 'Plus Jakarta Sans, sans-serif',
                        fontSize: 14,
                        borderRadius: 10,
                    },
                }}
            />
        </AuthProvider>
    </BrowserRouter>
);

export default App;